declare namespace $ {

	type $mol_image__uri_shm_hitalama_text_embed_image_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed_image['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_hitalama_text_embed_image_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed_image['title'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_image__uri_shm_hitalama_text_embed_image_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed_image['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_hitalama_text_embed_image_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_embed_image['title'] >
		,
		ReturnType< $mol_image['title'] >
	>
	export class $shm_hitalama_text_embed_image extends $shm_media {
		Preview_image( ): $mol_image
		Full_image( ): $mol_image
	}
	
}

//# sourceMappingURL=image.view.tree.d.ts.map